angular.module('cimerFrontEndApp').directive('authorizedLink', ['$window', '$uibModal', '$timeout','$rootScope','Session', function ($window, $uibModal,$timeout,$rootScope,Session) {
    'use strict';
    return {
        restrict: 'E',
        templateUrl: '/Content/Templates/authorizedLinkTemplate.html',
        //require: 'ngModel',
        scope: {
            href: '=href',
            documentId: '=documentId'
        },
        link: function (scope, element, attrs, ctrls) {
            //Setup function to get authentication
            var getAuthenticationStatus = function () {
                var sessionObject = Session.getSessionObject();
                scope.userAuthenticated = sessionObject.isAuthenticated;
            };

            //Get the initial authentication statups
            getAuthenticationStatus();

            //Update our authentication status when there is a login event
            $rootScope.$on('login', function () {
                getAuthenticationStatus();
            });

            //Handles redirecting someone to the authenticated link
            var download = function () {
                if (!scope.downloaded) {
                    scope.downloaded = true;
                    $window.location = scope.href + scope.documentId;
                }
            };

            //Handles asking someone for their login
            var login = function () {
                var loginModal = $uibModal.open({
                    animation: true,
                    templateUrl: '/Content/Templates/loginModal.html?v=' + versionKey,
                    controller: 'loginModalCtrl',
                    resolve: {
                        Session: function () {
                            return Session;
                        }
                    }

                });
                loginModal.rendered.then(function () {
                    $('#username').focus();
                });
                loginModal.result.then(function () {
                    getAuthenticationStatus();
                    //Trigger the download
                    download();
                });
            };

            //Click handler for 
            scope.click = function () {
                if (scope.userAuthenticated) {
                    download();
                } else {
                    login();
                }
            };
        }
    };

}]);